import React from 'react';
import { translate } from '../../types/EnumTranslations';
import { BaseComponentImpl } from '../../types/implementations';
import { Building } from '../../types/protocols';
import BuildingCustomButton from '../BuildingDetails/BuildingCustomButton';

interface ComponentButtonListProps {
    components: BaseComponentImpl[];
    building: Building;
    defaultImagePath: string;
    selectedComponentKey: string | null;
    hoveredKey: string | null;
    onComponentClick: (key: string) => void;
    onMouseEnter: (key: string) => void;
    onMouseLeave: () => void;
    getMetadata?: (component: BaseComponentImpl) => string[];
}

const ComponentButtonList: React.FC<ComponentButtonListProps> = ({
    components,
    building,
    defaultImagePath,
    selectedComponentKey,
    hoveredKey,
    onComponentClick,
    onMouseEnter,
    onMouseLeave,
    getMetadata,
}) => {
    return (
        <>
            {components.map((component) => (
                <BuildingCustomButton
                    key={component.key}
                    title={component.displayName(building)}
                    metadata={getMetadata ? getMetadata(component) : [translate(component.type)]}
                    imagePath={component.specificType?.value ? `types/${component.specificType.value}.png` : defaultImagePath}
                    componentType={component.specificType?.value ?? undefined}
                    onClick={() => onComponentClick(component.key)}
                    onMouseEnter={() => onMouseEnter(component.key)}
                    onMouseLeave={onMouseLeave}
                    isHovered={hoveredKey === component.key}
                    className={`flat-button ${selectedComponentKey === component.key ? 'flat-button--active' : ''}`}
                />
            ))}
        </>
    );
};

export default ComponentButtonList;
